/**
 * Region Geo Modal — Contentful GraphQL (manual; run `yarn contentful:generate` after
 * schema pull to regenerate shared types if needed).
 *
 * Content type / field IDs must match Contentful “Copy API name”:
 * - Content model “Region Geo Modal” → typically `regionGeoModal`
 * - Fields: `welcomeHeading`, `welcomeBody`
 *
 * @override Re-exports the autogenerated queries from the parent `pwa-contentful`
 * layer so the public API stays intact (per `package-inheritance` rule §"Core
 * Principle"). Without this, the autogenerated hook
 * `@amblique/contentful/app/contentful/hooks/use-region-geo-modal` cannot resolve
 * `getBaseRegionGeoModalById`, `getRegionGeoModalById`, `getFullRegionGeoModalById`
 * (and the matching collection variants) and webpack emits an
 * "export ... was not found" warning on every HMR rebuild.
 */
import gql from 'graphql-tag';

export * from '@amblique/contentful/app/contentful/queries/region-geo-modal.queries';

export const getRegionGeoModalCopy = gql`
  query GetRegionGeoModalCopy($locale: String, $preview: Boolean) {
    regionGeoModalCollection(limit: 1, locale: $locale, preview: $preview) {
      items {
        welcomeHeading
        welcomeBody
      }
    }
  }
`;
